import { ColumnModel, FkModel, FltModel } from "./column/column.model";
import { SafeStyle, SafeHtml } from "@angular/platform-browser";

export class GridModel {

    constructor() {
        this.pagination = new paginationModel(10)
        this.sta = 1
        this.dats_vis = []
        this.dats = []
    }

    id: string
    nam: string
    tit: string
    dsc: string
    num: boolean // number column => (true).visible, false.hidden
    act: boolean // action column -> (true).visible, false.hidden
    flt: boolean // filter bar-> (true).visible, false.hidden
    sela: number // selectable => (1).non-selectable, 2.selectable, 3.multi-selectable
    sty: string
    cls: string
    styp: string
    clsp: string
    row: boolean
    cols: ColumnModel[]
    cols_vis: ColumnModel[]
    dats: any[][]
    dats_vis: any[][]
    dats_sel: any[][]
    dat_foc: any[]
    dat_edt: any[]
    dat_edt_tmp: any[]
    dats_prop: any[][] // [[row_id, selected]]

    prm: PermitModel
    stus: StatuModel[]
    ord: number
    dis: number // gridform (default: 21)=> 1.none, 2.normal, 3.card, 4.nav, 5.modal;   ex: 24-> grid=2, form=4
    grp: number // config of cmp
    lod: boolean
    edit_id: string
    add_id: string // if null use from edit_id
    det_id: string
    pars: any[][] // [ fk_nam: string, parent_id: number, parent_nam: string, auto_referesh: boolean, row_id: number, ]
    bhtm: string // befor html
    ahtm: string // after html
    codsb: string // befor save (insert or update) on server (if return false insdate not run)
    codc: string // after initial grid on client 
    codl: string // after load data on server
    codsa: string // after save (insert or update) on server
    database_id: string
    scm: string
    tnam: string
    talses: string[]
    psiz: number
    foot: boolean
    evts: EventModel[]
    dras: EventModel[]
    cnf: CnfModel
    frm: FrmModel
    skin: number

    disf: number // display form: 1.none, 2.normal, 3.card, 4.nav, 5.modal
    pagination: paginationModel
    inloading: boolean
    dyn: any // {} nodb for permit
    sta: number // state => (1).view, 2.edit, 3.new
    row_i: number // current edit row index
    iol: boolean // is opts loaded?
    ssty: SafeStyle
    sstyp: SafeStyle
    sql: string
    loading: boolean
    cform: number // current form - wich form is open now for edit/insert (1).grid, 2.form 
}

export class PermitModel {
    id: string
    role_id: string
    grid_id: string
    gs_grid_id: string
    wh: string
    see_enabled: string
    see_diabled: string
    creating: number
    detail: string
    edit: string
    remove: string
    status_up: string
    status_down: string
    enable: string
    disable: string
    cols: ColumnPermitModel[]
}

export class ColumnPermitModel {
    vals: string
    prmc: {
        role_id: string
        statu: number[]
        exist: number // 1.no, 2.yes
        add: number // 1.no-add, 2.user-add, 3.system-add, 4.user-ifnot-system-add
        edit: number // 1.no-edit, 2.user-edit, 3.system-edit, 4.user-ifnot-system-edit
    }
    flt: FltModel
    fks: FkModel
}

export class StatuModel {
    id: string
    tnam: string
    tit: string
    lev: number
}

export class EventModel {
    id: string
    grid_id: string
    key: string
    cnf: any
    tit: string
    js: string
    ico: string
    sico: SafeHtml
    srt: number
    dsc: string
}

export class paginationModel {
    first: boolean
    prev: boolean
    next: boolean
    last: boolean
    pages: any[]

    page_number: number
    page_sizes: number[]
    page_size: number
    total_count: number

    constructor(psiz?: number) {
        this.first = false
        this.prev = false
        this.next = false
        this.last = false
        this.pages = []
        this.page_number = 1
        this.page_sizes = [5, 10, 15, 20, 30, 50, 100, 500, 1000, 10000]
        this.page_size = psiz || 10
        this.total_count = 0
    }
}

export class LoadFltModel {
    als: string
    val: string
    mod: number // mod => (1).=, 2.between, 3.in, 4.>, 5.<, 6.>=, 7.<=, 8.<>, 9.is null, 10.is not null 
}

export class LoadOptModel {
    limit?: number
    offset?: number
    apply?: boolean
    edit_cancel?: boolean
    orderby?: string
    with_filter?: boolean // just for frontend

    constructor() {
        this.with_filter = true
        this.edit_cancel = true
    }
}

export class CnfModel {
    add_mode: number // grid config in here

}

export class FrmModel {
    dep: number // formy config in here

}